import { useEffect, useRef, useState } from 'react';

const ExpandableMenu=({navItem})=>{
    const [isVisible,setIsVisible]=useState(false)
    const [isMenuExpanded,setIsMenuExpanded]=useState(false);
    const navMenuRef = useRef(null);
    const timeoutRef = useRef(null);

    const handleMenuExpansion=()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current); // Clear any existing timeout
        }
        setIsVisible(true);
    }
    
    const handleMenuCollapse=()=>{
        setIsMenuExpanded(false);
        timeoutRef.current = setTimeout(() => {
            setIsVisible(false);
        }, 300);
    }

    useEffect(()=>{
        if(isVisible)
        {
            setTimeout(()=>{
                setIsMenuExpanded(true);
            },1);
        }
    },[isVisible]);

    return(
        <>
            <button className="flex text-white items-center justify-between py-2 pl-3 pr-4 hover:text-deep-red lg:p-0 w-auto focus:text-deep-red w-full md:w-[115px]" onClick={()=>{
                if(isVisible)
                {
                    handleMenuCollapse();
                }
                else
                {
                    handleMenuExpansion();
                }
            }}>
                {navItem.head}
                <svg className="text-deep-red inline w-2.5 h-2.5 ml-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4"/>
                </svg>
            </button>

            {
                isVisible?
                    <div 
                        ref={navMenuRef} 
                        className="text-center alim-inline-nav transition-[height] duration-300 overflow-hidden"
                        style={{
                            height: isMenuExpanded&&navMenuRef.current? 
                                `${navMenuRef.current.scrollHeight}px`
                            :
                                "0px",
                        }}
                    >
                        <div className="flex z-10 font-normal w-full pl-3 flex-col py-2">
                            {
                                navItem.subhead.map((subItem, subItemIndex)=>{
                                    return(
                                        <a key={subItemIndex} href={subItem.url} className="block px-4 py-2 text-sm nav-item">{subItem.text}</a>
                                    );
                                })
                            }
                        </div>
                    </div>
                :
                    null
            }
        </>
    );
}

export default ExpandableMenu;